import {
  DocumentStipComponent
} from 'app/modules/borrower/components/borrower-details/workflow/stipulations/document-stip/document-stip.component';
import {
  LenderStipsComponent
} from 'app/modules/borrower/components/borrower-details/workflow/stipulations/lender-stips/lender-stips.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import {
  RequestBuilderComponent
} from 'app/modules/borrower/components/borrower-details/workflow/stipulations/request-builder/request-builder.component';
import {
  StipTemplateComponent
} from 'app/modules/borrower/components/borrower-details/workflow/stipulations/stip-template/stip-template.component';
import {
  StipulationsComponent
} from 'app/modules/borrower/components/borrower-details/workflow/stipulations/stipulations.component';
import {
  TextStipComponent
} from 'app/modules/borrower/components/borrower-details/workflow/stipulations/text-stip/text-stip.component';
import {
  CollapsibleContainerModule
} from 'ng2-app/borrower-fd/borrower-fd-sidebar/collapsible-container/collapsible-container.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  StipCreateDialogComponent
} from 'lendio-borrower/components/borrower-details/workflow/stipulations/stip-create-dialog/stip-create-dialog.component';
import { ConfirmationDialogModule } from 'ng2-app/modules/confirmation-dialog/confirmation-dialog.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { DealModule } from 'ng2-app/deal/deal.module';
import { LetDirectiveModule } from 'ng2-app/modules/directives/let/let.directive.module';
import {
  DocumentStipConfirmDialogComponent
} from 'lendio-borrower/components/borrower-details/workflow/stipulations/document-stip/document-stip-confirm-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    DocumentStipConfirmDialogComponent,
    DocumentStipComponent,
    LenderStipsComponent,
    RequestBuilderComponent,
    StipTemplateComponent,
    StipulationsComponent,
    TextStipComponent,
    StipCreateDialogComponent,
  ],
  exports: [
    StipulationsComponent,
    StipCreateDialogComponent,
    DocumentStipConfirmDialogComponent,
  ], imports: [
    MatSelectModule,
    CollapsibleContainerModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    ConfirmationDialogModule,
    MatDialogModule,
    MatMenuModule,
    DealModule,
    LetDirectiveModule,
    MatProgressSpinnerModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class StipulationsModule { }
